import { render, staticRenderFns } from "./GeneralDialog.vue?vue&type=template&id=0bb22cb1"
import script from "./GeneralDialog.vue?vue&type=script&lang=js"
export * from "./GeneralDialog.vue?vue&type=script&lang=js"
import style0 from "./GeneralDialog.vue?vue&type=style&index=0&id=0bb22cb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports